import { RouteObject } from 'react-router-dom';

import { SettingsIntegrations } from './SettingsIntegrations';

export const integrationsRoute: RouteObject = {
  path: 'integrations',
  element: <SettingsIntegrations />,
};
